import styled from 'styled-components';

import {Texto} from './Utils';

const CardContainer =  styled.div`
    max-width:${props => props?.width ? props.width : '100%' };
    background: white;
    box-shadow: 2px 2px 2px rgb(0 0 0 / 10%), -1px 0 2px rgb(0 0 0 / 5%);
    overflow: hidden;
    margin: 1rem;
    margin: .5rem auto;
`;

const ContainerTitulo =  styled.div`
    padding: .5rem 1rem;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    box-shadow: 2px 2px 2px rgb(0 0 0 / 5%);
`;

const ContainerDados =  styled.div`
    padding-top: .5rem;
`;


const Card = ({children, titulo, className, width}) => {
	return(
		<CardContainer className={className} width={width}>
            <ContainerTitulo>
                <Texto className="m-0" tamanho="21px" weight="400">{titulo}</Texto>
            </ContainerTitulo>
            <ContainerDados>
                {children}
            </ContainerDados>
        </CardContainer>
	)
}

export default Card
